import { useEffect } from "react";
import { Helmet } from "react-helmet";

const TermsAndCondition = () => {
  useEffect(() => {
    scrollToTop();
  }, []);
  const scrollToTop = () => {
    const top = document.getElementById("top") as HTMLElement;
    top.scrollIntoView();
  };
  return (
    <div className="term-condition-page" id="top">
      <Helmet>

        <title>{'Terms & Conditions'}</title>

        <meta name="description" content={'Details of Prime Direct Distribution Terms and conditions of sale.'} />

        <meta property="og:title" content={'Terms & Conditions'} />

        <meta property="og:description" content={'Details of Prime Direct Distribution Terms and conditions of sale.'} />

      </Helmet>
      <div className="container">
        <h3 className="main-heading">Terms and Conditions of Sale</h3>
        <ol>
          <li>New release product made available prior to release date must not be sold or displayed until the official release date unless expressly authorised otherwise. Breach of this provision will result in no further pre-release product being delivered to you.</li>
          <li>A receipt is required for all goods delivered and all details set out on that receipt shall be deemed correct. In the event of any errors thereon, these must be notified to the driver at the time of delivery and acknowledged by him amending the documentation accordingly. In the event any goods are subsequently found to be damaged, written notice thereof must be submitted to Prime Direct head office within three working days.</li>
          <li>A charge of Ten Pounds will be made for proof of delivery where it is proved that delivery was made and a signature obtained.</li>
          <li>Risk in all goods passes to you on delivery and Prime Direct will therefore accept no responsibility or liability in respect to goods damaged thereafter.</li>
          <li>Title of all goods remains with Prime Direct until account is paid in full.</li>
          <li>In the event of late payment, Prime Direct reserves the right to charge interest on all outstanding sums, at the rate of 3% above Bank of England base rate. Prime Direct at its sole discretion reserves the right to withhold all further orders until such sums are paid in full, or if an account exceeds their credit limit.</li>
          <li>Prime Direct will make every endeavour to supply goods at the agreed price, but can increase its prices by written notice to you having immediate effect, to take account of fluctuations in exchange rates, interest rates, increases in cost of materials or other factors outside of our control.</li>
          <li>All goods are purchased from Prime Direct on a firm sales basis.</li>
          <li>Prime Direct will not accept back any stock which is stickered, marked, defaced or in any way faulty unless you have notified us of such fault within three working days of delivery.</li>
          <li>Prime Direct reserves the right to vary any goods ordered under certain circumstances, for instance if a track listing is altered between order and delivery.</li>
          <li>Prime Direct will endeavour to deliver all goods on order as promptly as possible, but shall not be liable for delay or failure of delivery, whatever the reason.</li>
          <li>Prime Direct accepts no liability for any indirect, incidental or consequential damages. Furthermore, the company is not liable for any representation or implied warranty.</li>
          <li>In case of any claims made against Prime Direct, liability is limited to replacing defective materials, or the cost price thereof.</li>
          <li>All claims, or any complaints, should be made in writing and addressed to the Prime Direct head office.</li>
          <li>These terms and conditions are subject to the Laws of England and Wales.</li>
        </ol>
      </div>
    </div>
  );
};
export default TermsAndCondition;
